module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Light.2b469537.woff2";